/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_link_minecraft_login_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please log in to your BeaconAuth account to complete the link.`)
};

const zh_hans1_link_minecraft_login_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请先登录您的 BeaconAuth 账号以完成绑定。`)
};

const zh_hant1_link_minecraft_login_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請先登入您的 BeaconAuth 帳號以完成綁定。`)
};

const fr_link_minecraft_login_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez vous connecter à votre compte BeaconAuth pour terminer la liaison.`)
};

const de_link_minecraft_login_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte melden Sie sich bei Ihrem BeaconAuth-Konto an, um die Verknüpfung abzuschließen.`)
};

const ja_link_minecraft_login_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連携を完了するにはBeaconAuthアカウントにログインしてください。`)
};

const ko_link_minecraft_login_required = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연동을 완료하려면 BeaconAuth 계정에 로그인하세요.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const link_minecraft_login_required = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.link_minecraft_login_required(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("link_minecraft_login_required", locale)
	if (locale === "en") return en_link_minecraft_login_required(inputs)
	if (locale === "zh-Hans") return zh_hans1_link_minecraft_login_required(inputs)
	if (locale === "zh-Hant") return zh_hant1_link_minecraft_login_required(inputs)
	if (locale === "fr") return fr_link_minecraft_login_required(inputs)
	if (locale === "de") return de_link_minecraft_login_required(inputs)
	if (locale === "ja") return ja_link_minecraft_login_required(inputs)
	return ko_link_minecraft_login_required(inputs)
};